import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import 'firebase/functions';
import Shoutouts from '../shoutouts/Shoutouts';
import Users from '../users/Users';
import Teams from '../teams/Teams';
import Profile from '../profile/Profile';
import './Dashboard.scss';
import NavBar from './NavBar';
import { hideToast } from '../../actions/ToastActions';
import AdminModal from '../admin/AdminModal';

class Dashboard extends Component {
  lastPath = '';

  UNSAFE_componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      if (location.pathname !== this.lastPath && this.props.shown) {
        this.props.hideToast();
      }
      const commentToFeed = this.lastPath.indexOf('/shoutouts/') !== -1 && location.pathname === '/shoutouts';
      this.lastPath = location.pathname;
      if (!commentToFeed && location.pathname.indexOf('/shoutouts/') === -1) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }

    });
  }

  componentWillUnmount() {
    this.props.hideToast();
    this.unlisten();
  }

  render() {
    const { history } = this.props;
    return (
      <div className="dashboard-container">
        <NavBar history={history} />
        <AdminModal />
        <main id="main-container" className="content">
          <Route path={"/shoutouts/:id?"} component={Shoutouts} />
          <Route path={"/users"} component={Users} />
          <Route path={"/profile/:id"} component={Profile} />
          <Route path={"/teams"} component={Teams} />
          <Route exact path="/" render={() => <Redirect to={"/shoutouts"}/>} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = ({ toastStore }) => {
  const { shown } = toastStore;
  return { shown };
};

export default connect(mapStateToProps, { hideToast })(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/dashboard/Dashboard.js